import script from "./CashbookPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CashbookPage.vue?vue&type=script&setup=true&lang=js"

import "./CashbookPage.vue?vue&type=style&index=0&id=3aa99c50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa99c50"]])

export default __exports__